import {api, ContentType} from '../../api';
import {createMutation} from '../../lib';

const {postImportsExcelSr} = api.imports;

export const usePostImportsExcelSr = createMutation((params: Parameters<typeof postImportsExcelSr>) => {
  const [query, data, reqParams] = params;
  return postImportsExcelSr(query, data, {
    type: ContentType.FormData,
    ...reqParams,
  });
});
